export enum EnabledTypes {
  None = 0,
  Enabled = 1,
  Disabled = 9,
}

export function getEnabledTypeName(value: EnabledTypes): string {
  switch (value) {
    case EnabledTypes.None: return '未指定';
    case EnabledTypes.Enabled: return '有効';
    case EnabledTypes.Disabled: return '無効';
  }
}
